<app-resource-page-status [status]="resourcePage.status"></app-resource-page-status>
